// extracted by mini-css-extract-plugin
export default {"card":"PersonMainCard_card__FmZY-"};